import * as React from "react";
import {Button} from "react-bootstrap";
import {MapType} from "Stores/commonStore";


interface CheckboxButtonProps{
    onClick: (obj: MapType) => void
    data: MapType
    isSelected: boolean
}

export class CheckboxButton extends React.Component<CheckboxButtonProps>{
    handleClick = () => {
        this.props.onClick(this.props.data);
    };

    render(){
        return (
            <Button onClick={this.handleClick} className="add-remove-button" variant={"icon"}>
                { this.props.isSelected ? <i className="icon icon-check-square"/> : <i className="icon icon-square-o"/> }
            </Button>
        );
    }
}
